import styled from 'styled-components';
import { Tabs } from 'antd';

const BEFORE_BG = '#f5f5f5';
const BEFORE_HEADER_BG = '#e8e8e8';
const BEFORE_TEXT = '#8c8c8c';
const AFTER_BG = '#e6f4ff';
const AFTER_HEADER_BG = '#bae0ff';
const AFTER_TEXT = '#0958d9';
const ALERT_COLOR = '#d46b08';

/**
 * 상단 요약 수치 블록. 건수 카운트를 dl/dt/dd 로 구조화해
 * 기준일 변경 PreviewModal 의 StyledSummary 와 동일한 톤으로 정리.
 */
export const StyledSummary = styled.div`
  display: flex;
  gap: 24px;
  padding: 12px 16px;
  background: #fafafa;
  border: 1px solid #e7eaec;

  dl {
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  dt {
    font-size: 12px;
    color: #8c8c8c;
  }
  dd {
    margin: 0;
    font-size: 14px;
    color: #333;

    strong {
      font-size: 18px;
      color: #6200ea;
    }
  }
  dl.alert dd {
    color: ${ALERT_COLOR};
    font-weight: 600;
  }
`;

/**
 * Preview 탭. "적용 대상 탭" 의 변경 전/후 컬럼 그룹 배경색도 여기서 처리.
 * antd Table 의 columns 에 className 을 주면 th/td 양쪽에 적용된다.
 */
export const StyledTabs = styled(Tabs)`
  .ant-table-thead > tr > th.before-group {
    background: ${BEFORE_HEADER_BG};
    color: ${BEFORE_TEXT};
  }
  .ant-table-thead > tr > th.after-group {
    background: ${AFTER_HEADER_BG};
    color: ${AFTER_TEXT};
  }
  .ant-table-tbody > tr > td.before-cell {
    background: ${BEFORE_BG};
  }
  .ant-table-tbody > tr > td.after-cell {
    background: ${AFTER_BG};
  }
`;

export const StyledBeforeCell = styled.span`
  color: ${BEFORE_TEXT};
  text-decoration: line-through;
  text-decoration-color: #bfbfbf;
`;

export const StyledAfterCell = styled.span`
  color: ${AFTER_TEXT};
  font-weight: 600;
`;

/**
 * 월 변경 영향 탭의 "변경 전/후 월" 셀에서 사용. 월(YYYY-MM) 두 개의 차이를
 * 시각적으로 강조해 회계가 한눈에 영향 월을 파악하도록 한다.
 */
export const StyledMonthCell = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  background: ${AFTER_BG};
  color: ${AFTER_TEXT};
  font-weight: 600;
`;
